import type { AddressMatch } from '@/services/apis/addressSearch/schemas';
import { createSliceWithImmer } from 'zustand-slices/immer';

export type FeedbackCardVisible =
  | 'already-has-service'
  | 'visit-superloop'
  | 'great-news'
  | 'bad-news'
  | null;

type AddressSlice = {
  searchAddress: string;
  latestSelectedAddresses: AddressMatch[];
  feedbackCardAddressSearchVisible: FeedbackCardVisible | null;
  feedbackCardRecentSearchVisible: FeedbackCardVisible | null;
  canDisplayAddressList: boolean;
};

type AddressSliceActions = {
  setSearchAddress: (value: string) => (state: AddressSlice) => void;
  setLatestSelectedAddress: (
    latestSelectedAddress: AddressMatch
  ) => (state: AddressSlice) => void;
  setFeedbackCardAddressSearchVisible: (
    cardVisible: FeedbackCardVisible
  ) => (state: AddressSlice) => void;
  setFeedbackCardRecentSearchVisible: (
    cardVisible: FeedbackCardVisible
  ) => (state: AddressSlice) => void;
  setCanDisplayAddressList: (
    canDisplayAddressList: boolean
  ) => (state: AddressSlice) => void;
};

const MAX_HISTORY_SIZE = 5;

export const addressSlice = createSliceWithImmer<
  'addressStore',
  AddressSlice,
  AddressSliceActions
>({
  name: 'addressStore',
  value: {
    searchAddress: '',
    latestSelectedAddresses: [],
    feedbackCardAddressSearchVisible: null,
    feedbackCardRecentSearchVisible: null,
    canDisplayAddressList: false,
  },
  actions: {
    setSearchAddress: (value) => (state) => {
      state.searchAddress = value;
    },
    setLatestSelectedAddress: (latestSelectedAddress) => (state) => {
      //Latest selected address is added to the beginning of the array
      // The order is: latestSelectedAddress, ...previousAddresses
      state.latestSelectedAddresses = [
        latestSelectedAddress,
        ...state.latestSelectedAddresses,
      ].slice(0, MAX_HISTORY_SIZE);
    },
    setFeedbackCardAddressSearchVisible: (cardVisible) => (state) => {
      state.feedbackCardAddressSearchVisible = cardVisible;
    },
    setFeedbackCardRecentSearchVisible: (cardVisible) => (state) => {
      state.feedbackCardRecentSearchVisible = cardVisible;
    },
    setCanDisplayAddressList: (canDisplayAddressList) => (state) => {
      state.canDisplayAddressList = canDisplayAddressList;
    },
  },
});
